/* eslint-disable import/prefer-default-export */
import {filterResource} from "./filters";

/**
 * Generate Styles from FieldParagraphFieldObjectSectionStyle
 *
 * @param field
 * @param additionalClassNames
 * @param disableImage
 * @return {{classNames: string, css: {}}}
 */
export const fieldObjectSectionStyleCss = (field, additionalClassNames="", disableImage=false) => {
    const styles = {
        id: null,
        classNames: '',
        css: {
            position: 'relative'
        },
        childBackground: {
            css: {
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0
            },
            isActive: false
        }
    };

    if (field.entity && field.entity.fieldCssId) {
        styles.id = field.entity.fieldCssId;
    }

    if (additionalClassNames) {
        styles.classNames += ` ${additionalClassNames}`;
    }

    if (!field) return styles;

    // Text Color
    if (field.entity.fieldColorText) {
        styles.css.color = field.entity.fieldColorText
    }

    // Background Color
    if (field.entity &&
        field.entity.fieldColorBackground) {
        styles.css.backgroundColor = field.entity.fieldColorBackground;
    }

    // Alignment, Additional CSS
    if (field.entity) {

        if (field.entity.fieldVarTextAlignment) {
            styles.classNames += ` textalignment--${field.entity.fieldVarTextAlignment}`
        }

        if (field.entity.fieldVarAdditionalCss) {
            styles.classNames += ` ${field.entity.fieldVarAdditionalCss}`;
        }
    }

    // Background Image
    if (field.entity &&
        field.entity.fieldObjectBackground &&
        field.entity.fieldObjectBackground.entity) {

        const background = field.entity.fieldObjectBackground.entity;

        if (background.fieldColorBackground) {
            styles.childBackground.css.backgroundColor = background.fieldColorBackground;
            styles.childBackground.isActive = true;
        }

        if (background.fieldObjectImg && background.fieldObjectImg.url) {
            styles.childBackground.url = filterResource(background.fieldObjectImg.url);
            styles.childBackground.alt = background.fieldObjectImg.alt;

            if (!disableImage) {
                styles.childBackground.css.background = `url("${styles.childBackground.url}") no-repeat center center`;
                styles.childBackground.css.backgroundSize = 'cover';
                styles.childBackground.isActive = true;
            }
        }
        if (background.fieldObjectImg && background.fieldObjectImg.entity && background.fieldObjectImg.entity.fieldMediaImage && background.fieldObjectImg.entity.fieldMediaImage.url) {
            styles.childBackground.url = filterResource(background.fieldObjectImg.entity.fieldMediaImage.url);
            styles.childBackground.alt = background.fieldObjectImg.entity.fieldMediaImage.alt;

            if (!disableImage) {
                styles.childBackground.css.background = `url("${styles.childBackground.url}") no-repeat center center`;
                styles.childBackground.css.backgroundSize = 'cover';
                styles.childBackground.isActive = true;
            }
        }

        if (background.fieldVarBackgroundOpacity && styles.childBackground.isActive) {
            styles.childBackground.css.opacity = background.fieldVarBackgroundOpacity;
        }

        if (background.fieldVarDarkOverlay) {
            styles.classNames += ' darkOverlay';
        }

    }

    return styles;
};



// WEBPACK FOOTER //
// ./frontend/helpers/createStyles.js